import { Link } from "react-router-dom";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@babackapp/ui/components/tooltip";
import useTranslation from "@babackapp/translations/use-translation";

interface ConflictWarningProps {
  warningMessage: string;
  conflictingReturns: Array<{
    returnRequestId: string;
    returnRequestName: string;
  }>;
  adjustedMaxQuantity: number;
  shopId: string;
}

export function ConflictWarning({
  warningMessage,
  conflictingReturns,
  adjustedMaxQuantity,
  shopId,
}: ConflictWarningProps) {
  const t = useTranslation();

  return (
    <span className="text-xs text-muted-foreground flex items-center gap-1">
      <TooltipProvider delayDuration={100}>
        <Tooltip>
          <TooltipTrigger asChild>
            <span className="cursor-help text-blue-600 dark:text-blue-400 hover:underline">
            <span>({warningMessage})</span>
            </span>
          </TooltipTrigger>
          <TooltipContent className="max-w-xs">
            <div className="space-y-1">
              <p className="text-xs mb-2">
                {t("returns.conflicts.already_in")}
              </p>
              {conflictingReturns.map((ret) => (
                <Link
                  key={ret.returnRequestId}
                  to={`/shops/${shopId}/returns/${ret.returnRequestId}`}
                  className="block text-xs underline hover:text-primary-foreground/80"
                >
                  {t("returns.conflicts.return_link", {
                    id: ret.returnRequestId,
                  })}
                </Link>
              ))}
              {adjustedMaxQuantity > 0 && (
                <p className="text-xs mt-2 pt-2 border-t border-border/50">
                  {t("returns.conflicts.max_adjustable", {
                    max: adjustedMaxQuantity,
                  })}
                </p>
              )}
            </div>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </span>
  );
}
